/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Notification } from '../../models/notification';

export interface UpdateNotification$Params {
}

export function updateNotification(http: HttpClient, rootUrl: string, params?: UpdateNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Notification>>> {
  const rb = new RequestBuilder(rootUrl, updateNotification.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Notification>>;
    })
  );
}

updateNotification.PATH = '/api/notification/update';
